import React from "react";
import { Footer } from "../Footer";
import { Navbar } from "../Navbar";

export const privacyData = [
    {
        title: "PRIVACY POLICY FOR BLUEBERRY TRAVEL DMC",
        desc: [
            "https://www.blueberrydmc.com/ is an online travel portal that provides information on various cities of the world and recommend travel package through visitor’s opinion.",
            "We believe in our visitors for giving their opinion/views on any subject and the same is not biased.",
            "We are taking all measures to ensure that all the personal information shared by our visitors shall remain confidential.",
            "We recommend our visitors that before submitting their personal information on our web site, please read this policy carefully to learn about our privacy practices."
        ]
    },
    {
        title: "PRIVACY POLICY",
        desc: [
            "Once a visitor provides his personal information like name, e-mail ID, phone number, address, user ID & passwords, or any other travel related information, the same is stored in our database and that is protected at our end.",
            "We take all measures to ensure that the information is not disclosed to any third party.",
            "Only authorized employees at Blueberry travel DMC are allowed to manage such personal information and the same is protected through several firewalls to stop leakage."
        ]
    },
    {
        title: "INFORMATION COLLECTION",
        desc: [
            "Although the visitor has the option not to provide all or any information, some general information is required to enjoy the benefits of being a registered member.",
            "Visitors of https://www.blueberrydmc.com/ will have an option to provide contact information about them.",
            "https://www.blueberrydmc.com/ procure session data that includes your IP address and web browser software."
        ]
    },
    {
        title: "USAGE OF INFORMATION",
        desc: [
            "Blueberry Travel DMC assumes it has the right to collect information about your online activity such as content viewed and pages visited.",
            "The information collected helps us understand user interests and improve services.",
            "This information also helps us collaborate with hotels, airlines, and partners to provide better deals or advertisements."
        ]
    },
    {
        title: "THIRD PARTY DISCLOSURE",
        desc: [
            "Blueberry travel DMC has a policy not to disclose visitor’s personal information to third parties who are not affiliated with us.",
            "If any link redirects to another website, users are advised to review that site's privacy policy as well."
        ]
    },
    {
        title: "HOW WE USE YOUR INFORMATION",
        desc: [
            "Operating and maintaining our website",
            "Enhancing, customizing, and expanding our services",
            "Understanding how visitors interact with our platform",
            "Developing new tools, content, and offerings",
            "Responding to inquiries and providing support",
            "Sending updates, marketing messages, and relevant communications",
            "Detecting, preventing, and addressing fraudulent activity"
        ]
    },
    {
        title: "RETENTION OF PERSONAL INFORMATION",
        desc: [
            "We retain your personal information only for as long as necessary to fulfill the purposes outlined in this policy or as required by applicable law."
        ]
    },
    {
        title: "YOUR RIGHTS AND CHOICES",
        desc: [
            "Accessing the personal data we hold about you",
            "Correcting or updating inaccurate data",
            "Requesting deletion of your personal information",
            "Restricting or objecting to how your data is processed",
            "Transferring your data to another service",
            "Withdrawing consent for optional data usage",
            "Filing a complaint with a data protection authority",
            "To exercise these rights, contact us at holidays@blueberrydmc.com. Identity verification may be required."
        ]
    },
    {
        title: "DATA PROTECTION RULES",
        desc: [
            "Blueberry DMC takes all possible measures and uses internal firewalls to ensure that your data and privacy are protected."
        ]
    },
    {
        title: "CROSS-BORDER DATA TRANSFERS",
        desc: [
            "Business operations may require transfer of personal information to entities or third parties outside UAE, including other countries.",
            "Such transfers are carried out with appropriate safeguards."
        ]
    },
    {
        title: "CHILDREN'S PRIVACY POLICY",
        desc: [
            "Protecting children’s privacy is important to us.",
            "We do not knowingly collect personal data from individuals under the age of 13.",
            "If such data is identified, it will be deleted immediately upon notification."
        ]
    },
    {
        title: "CHANGES TO PRIVACY POLICY",
        desc: [
            "We may revise this Privacy Policy periodically to reflect changes in practices or legal requirements.",
            "Users will be notified via email or website notice at https://www.blueberrydmc.com/ if significant changes are made."
        ]
    }
];

const PrivacyPolicy = () => {
    return (
        <>
            <Navbar />
            <div className="standard-padding">
                <h1 className="heading mb-4 text-center">Privacy Policy</h1>

                {privacyData.map((section, index) => (
                    <div key={index} className="mb-4">
                        <h2 className="subheading">{section.title}</h2>

                        {section.desc.map((para, i) => (
                            <p key={i} className="desc mb-2">
                                {para}
                            </p>
                        ))}
                    </div>
                ))}
            </div>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;